module.exports = __webpack_public_path__ + "assets/img/Cindy_Holcomb-LMSW.a8ebd56e.jpg";